
export enum Visibility {
    None,
    Mobile,
    Tablet,
    Laptop,
    Monitor,
    Television
}